import { ReactNode, PropsWithChildren } from "react";
import IntlProvider from "./IntlProvider";
import ErrorBoundary from "./ErrorBoundary";
import * as Sentry from "@sentry/react";
import DefaultHelmet from "./DefaultHelmet";
import { TooltipProvider } from "@/kit/ui/tooltip";
import { WorkersProvider } from "@/workers";

export interface Props {
  AuthProvider: (props: PropsWithChildren) => ReactNode;
  RelayEnvironment: (props: PropsWithChildren) => ReactNode;
  LocationProvider: (props: PropsWithChildren) => ReactNode;
  PostHogProvider: (props: PropsWithChildren) => ReactNode;
  Router: () => ReactNode;
}

const App = Sentry.withProfiler(
  ({
    AuthProvider,
    RelayEnvironment,
    LocationProvider,
    PostHogProvider,
    Router,
  }: Props) => {
    return (
      <LocationProvider>
        <IntlProvider>
          <ErrorBoundary>
            <DefaultHelmet />
            <AuthProvider>
              <RelayEnvironment>
                <TooltipProvider>
                  <WorkersProvider>
                    <PostHogProvider>
                      <Router />
                    </PostHogProvider>
                  </WorkersProvider>
                </TooltipProvider>
              </RelayEnvironment>
            </AuthProvider>
          </ErrorBoundary>
        </IntlProvider>
      </LocationProvider>
    );
  },
);

export default App;
